import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_2 = { class: "flex flex-col items-center text-center gap-2" }
const _hoisted_3 = { class: "font-semibold text-gray-900 text-lg" }
const _hoisted_4 = { class: "font-normal text-sm text-gray-600 w-[19rem] mb-6" }
const _hoisted_5 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_9 = { class: "mt-5 text-center" }
const _hoisted_10 = { class: "text-lg font-semibold mb-1" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-sm text-gray-600 mb-8" }

import { NewClassTeacher } from '@/interfaces/school-structure.interface';
import { useSchoolStore } from '@/stores/schoolStore';

type SchoolStoreType = ReturnType<typeof useSchoolStore>;


export default /*#__PURE__*/_defineComponent({
  __name: 'AddGradesClassesModals',
  props: {
    showSendDetails: { type: Boolean },
    showModal: { type: Boolean },
    errorMessage: {},
    teachers: {},
    schoolStore: {}
  },
  emits: ["update:showSendDetails", "update:showModal", "send-login"],
  setup(__props: any, { emit }) {

const props = __props;






return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg px-4 py-6 rounded-lg',
      open: props.showSendDetails,
      onLocalModalOpen: _cache[3] || (_cache[3] = (val) => emit('update:showSendDetails', val))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-green-save',
              title: 'rl green save',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.teachers.length > 0 ? _ctx.$t("add_grades_class_component.step_4.send_login") :
          _ctx.$t("add_grades_class_component.step_4.send_login_no_teachers")), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.teachers.length > 0 ? _ctx.$t("add_grades_class_component.step_4.send_details") :
          _ctx.$t("add_grades_class_component.step_4.send_details_no_teachers")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "rounded-lg py-2 px-6 text-white w-full font-semibold bg-blue-600 focus:outline-none",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('send-login')))
            }, [
              (props.schoolStore.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("add_grades_class_component.step_4.sending")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.teachers.length > 0 ? _ctx.$t("add_grades_class_component.step_4.btn_send") :
            _ctx.$t("add_grades_class_component.step_4.btn_send_no_teachers")), 1))
            ]),
            _createElementVNode("button", {
              class: "border-none text-sm py-2 px-6 text-gray-600 w-full font-normal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:showSendDetails', false)))
            }, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.not_yet")), 1),
            _createElementVNode("button", {
              class: "rounded-lg border border-gray-300 text-base py-2 px-6 text-gray-700 w-full font-semibold",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:showSendDetails', false)))
            }, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.btn_save")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg px-4 py-6 rounded-lg',
      open: props.showModal,
      onLocalModalOpen: _cache[4] || (_cache[4] = (val) => emit('update:showModal', val))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-red-fail',
              title: 'rl red fail',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t('bulk_learner_upload_component.invalid_data_modal.heading')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.errorMessage), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})